export enum TranslationsImportIssueType {
  Warning,
  Error
}
